import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/Affiliations/Affiliations.js
const Affiliations = createSectionForm({
  icon: "shield-star-line",
  title: "Affiliations",
  fields: [
    { name: "title", label: "Section Title" },
    {
      name: "logos",
      label: "Logos",
      type: "media",
      max: 20,
    },
  ],
});

export default Affiliations;
